import React from "react";

function AlertCircle({ fill, ...restProps }) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill={fill ?? ""}
      xmlns="http://www.w3.org/2000/svg"
      {...restProps}
    >
      <path
        d="m11.28 1.023-.56.06A10.685 10.685 0 0 0 7.18 2.12c-1.135.551-1.987 1.165-2.942 2.119-.961.959-1.595 1.841-2.141 2.981C.301 10.968.728 15.286 3.226 18.633c.475.636 1.527 1.683 2.174 2.164 3.964 2.948 9.266 2.937 13.237-.027.609-.454 1.679-1.524 2.133-2.133 2.974-3.985 2.974-9.289 0-13.274-.454-.608-1.523-1.677-2.13-2.128-1.595-1.186-3.275-1.875-5.217-2.139C13 1.038 11.574.99 11.28 1.023m2.04 2.078c2.563.387 4.804 1.83 6.24 4.019.303.463.743 1.359.932 1.9.346.993.485 1.845.485 2.98 0 1.493-.257 2.621-.897 3.94-.705 1.454-1.769 2.667-3.153 3.592-.789.528-2.051 1.056-3.019 1.265a9.053 9.053 0 0 1-7.538-1.778c-1.513-1.212-2.648-2.99-3.103-4.859-.186-.763-.244-1.272-.244-2.16 0-1.493.257-2.621.897-3.94a8.983 8.983 0 0 1 5.24-4.594c.705-.233 1.272-.348 2.18-.442.322-.033 1.571.015 1.98.077m-1.625 3.956a1.04 1.04 0 0 0-.567.459l-.108.184v4.606l.121.197c.068.11.205.253.311.325.471.316 1.102.171 1.407-.325l.121-.197V7.7l-.108-.184a1.005 1.005 0 0 0-1.177-.459m0 7.998a1.05 1.05 0 0 0-.567.461c-.091.156-.108.23-.108.484 0 .257.016.327.113.492.518.882 1.865.526 1.865-.492a.994.994 0 0 0-.535-.888 1.17 1.17 0 0 0-.768-.057"
        fill-rule="evenodd"
        fill={fill ?? ""}
      />
    </svg>
  );
}

export default AlertCircle;
